// extracted by mini-css-extract-plugin
export default {"container":"menu-footer__container___bTWCC","logout":"menu-footer__logout___Wej3S"};